<app-page-header icon="people" title="Usuarios" subtitle="Gestión de usuarios del sistema"></app-page-header>

<div class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="row m-5">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <div class="feature-card">
          <div class="icon">
            <i class="fas fa-users"></i>
          </div>
          <h3>Listado de Usuarios</h3>
          <p>Acceda al listado de Usuarios del sistema</p>
          <a routerLink="/usuarios-listado" class="btn btn-warning">Ver Usuarios</a>
        </div>
      </div>

      <div class="col-lg-6 col-sm-6 col-md-6">
        <div class="feature-card">
          <div class="icon">
            <i class="far fa-plus-square"></i>
          </div>
          <h3>Nuevo Usuario</h3>
          <p>Cree un nuevo Usuario en el sistema</p>
          <a routerLink="/usuario-alta" class="btn btn-success">Dar de alta Usuario</a>
        </div>
      </div>
    </div>
  </div>
</div>
